import {HttpClient} from '@angular/common/http';
import {Component, Injectable, Input, NgModule, OnChanges, SecurityContext, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl} from '@angular/platform-browser';

@Injectable({providedIn: 'root'})
export class SdIconRegistry {
  private readonly svg = new Map<string, string>();
  private readonly pending = new Map<string, Promise<string>>();

  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer,
  ) {}

  addSvgIcon(name: string, url: SafeResourceUrl): this {
    const raw = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, url) || '';
    this.pending.set(name, this.http.get(raw, {responseType: 'text'}).toPromise().then((svg) => {
      const markup = svg || '';
      this.svg.set(name, markup);
      return markup;
    }));
    return this;
  }

  getNamedSvgIcon(name: string): Promise<string> {
    if (this.svg.has(name)) {
      return Promise.resolve(this.svg.get(name) as string);
    }
    return this.pending.get(name) ?? Promise.resolve('');
  }
}

@Component({
  selector: 'sd-icon, sd-icon[svgIcon]',
  standalone: true,
  template: `@if (svgHtml) {<span class="inline-flex h-full w-full items-center justify-center [&>svg]:h-[1em] [&>svg]:w-[1em]" [innerHTML]="svgHtml"></span>} @else {<ng-content></ng-content>}`,
  host: {
    class: 'sd-icon material-icons inline-flex h-6 w-6 items-center justify-center text-[1.5rem] leading-none select-none',
    role: 'img',
    '[attr.aria-hidden]': 'true',
    '[class.material-icons-outlined]': 'fontSet === "material-icons-outlined"',
  },
})
export class SdIcon implements OnChanges {
  @Input() svgIcon?: string;
  @Input() fontSet?: string;
  @Input() fontIcon?: string;
  svgHtml: SafeHtml | null = null;

  constructor(
    private readonly registry: SdIconRegistry,
    private readonly sanitizer: DomSanitizer,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['svgIcon'] && this.svgIcon) {
      this.registry.getNamedSvgIcon(this.svgIcon).then((markup) => {
        this.svgHtml = markup ? this.sanitizer.bypassSecurityTrustHtml(markup) : null;
      });
    }
  }
}

@NgModule({
  imports: [SdIcon],
  exports: [SdIcon],
})
export class SdIconModule {}
